<div class="sap-part-numbers" *ngIf="(request$|async) ?? {} as orderData">
  <ng-container *ngIf="(sapNumberTypes$ | async) as _"></ng-container>
  <kendo-card width="100%">
    <kendo-card-header>
      <div class="sap-part-numbers__header">
        <div class="sap-part-numbers__titles">
          <div class="k-card-title">SAP Part Numbers</div>
          <div class="k-card-subtitle">Generated part numbers appear here once available.</div>
        </div>
        <div class="sap-part-numbers__actions">
          <button kendoButton 
                  [icon]="isRefreshing ? 'loading' : 'reload'" 
                  [disabled]="isRefreshing"
                  (click)="refreshData()"
                  title="Refresh SAP Numbers">
          </button>
          <button kendoButton themeColor="primary" (click)="openAddBitDialog()">Add Bit</button>
          <button
            kendoButton
            themeColor="primary"
            *ngIf="(showCreateEquipmentTemplate$ | async)"
            [disabled]="isCreatingEquipmentTemplate"
            (click)="createEquipmentTemplate()">
            Create Equipment Template
          </button>
        </div>
      </div>
    </kendo-card-header>
    <kendo-card-body>
      <kendo-grid [data]="(sapNumbers$ | async) ?? []" [sortable]="true" [pageable]="true" [height]="360">
        <kendo-grid-column title="Type" [width]="180">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ getSapNumberTypeDescription(dataItem) }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="number" title="SAP Number" [width]="200"></kendo-grid-column>
        <kendo-grid-column field="description" title="Description"></kendo-grid-column>
        <kendo-grid-column field="createdDate" title="Created" [width]="160">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.createdDate | date: 'short' }}
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </kendo-card-body>
  </kendo-card>
  <app-create-material-master-bits
    [open]="showAddBitDialog"
    [request]="orderData"
    (closed)="closeAddBitDialog()"
    (created)="onBitCreated()">
  </app-create-material-master-bits>
</div>
